// extracted by mini-css-extract-plugin
export default {"info":"MmLOLv","responsiveCells":"HUUSCc","time":"YkhiXV","title":"JYPgIG","fullEvents":"Knl9sh","compactEvents":"kP_9NO","titleContent":"jjpA8w","more":"SQKs0k"};